import {Seat} from "./seat.component"
import React from 'react';
import { getTravelsDetailsByKey, isValid, isValidArray } from "../../utils/utilities";
import { updateTicketForExtraSeats } from "../../actions/ticket.action";
import { message } from "antd";
import { revertCancelledTicket } from "../trip-tickets/trip-tickets-component/trip-tickets.module";

const onSeatDrop = (draggedSeat, targetSeat, reloadSeatLayout) => {

    if(isValidArray(draggedSeat.passengers) && draggedSeat.passengers.length >= 1){
        let passenger = draggedSeat.passengers[0];
        draggedSeat.ticket_id = passenger.ticket_id;
        draggedSeat.traveller_id = passenger.traveller_id;
        draggedSeat.phone_number = passenger.phone_number;
        draggedSeat.email_id = passenger.email_id;
        draggedSeat.full_name = passenger.full_name;
        draggedSeat.gender = passenger.gender;
        draggedSeat.pickup_location_id = passenger.pickup_location;
        draggedSeat.drop_location_id = passenger.drop_location;   
    }
    let ticket = {
        id: draggedSeat.ticket_id,
        phoneNumber: draggedSeat.phone_number,
        trip_id: draggedSeat.trip_id,
        trip_route_id: draggedSeat.trip_route_id,
        emailId: draggedSeat.email_id,
        pickup_location: draggedSeat.pickup_location_id,
        dropLocationId: draggedSeat.drop_location_id,
        updated_by: global.userName
    }
    let travellers = [
        {
            id: draggedSeat.traveller_id,
            fullName: draggedSeat.full_name,
            gender: draggedSeat.gender,
            seatNumber: targetSeat.seat_number,
            pickup_location: draggedSeat.pickup_location_id
        }
    ]
    let seats = [
        {
            ticket_id: draggedSeat.ticket_id,
            seatNumber: targetSeat.seat_number,
            tripId: draggedSeat.trip_id
        }
    ]
    let recordData = {ticket, travellers, seats, websiteUpdate: false};
    updateTicketForExtraSeats(recordData, (response) => {
        reloadSeatLayout(draggedSeat.trip_route_id);
        message.success('Seat changed successfully');
    }, (error) => {
        message.error('Failed to save changes');
    });
}

const onNotBoardedDrop = (draggedSeat, targetSeat, reloadSeatLayout, reloadNotBoarded) => {
    return new Promise((resolve, reject) => {
        if (!isValid(draggedSeat) || !isValid(draggedSeat.ticket_id)) {
            message.error('Missing ticket details for re-confirmation');
            reject();
            return;
        }
        // draggedSeat.seat_number identifies the cancelled traveller row.
        // targetSeat.seat_number is the empty seat we are re-confirming onto.
        revertCancelledTicket(draggedSeat.ticket_id, draggedSeat.seat_number, () => {
            const tripRouteId = draggedSeat.trip_route_id || targetSeat.trip_route_id;
            if (isValid(tripRouteId) && isValid(reloadSeatLayout)) {
                reloadSeatLayout(tripRouteId);
            }
            if (isValid(reloadNotBoarded)) {
                reloadNotBoarded();
            }
            message.success(`Passenger re-confirmed on seat ${targetSeat.seat_number}`);
            resolve();
        }, (errMsg) => {
            message.error(errMsg || 'Failed to re-confirm passenger');
            reject();
        }, targetSeat.seat_number);
    });
}

export const getSeatGrid = (seats, onSeatCLick, selectedSeats, showFarePopOver, dontAllowSelection,
    changeOldLayout, bothDecksTogether = false, oldSelectedSeats= [], reloadSeatLayout, isDragDropRequired,
    reloadNotBoarded)=>{
    let seatGrid = [[]];
    let lowerSeatGrid = [[]];
    let upperSeatGrid = [[]];
    let seattype=''
    let seatbooked=''
    let seatgender=''
    let className = ''
    let row_number = 0
    // let col_number = 0
    let col_number_array = []
    let available_seats = 0
    let available_windowSeats = 0
    let upperDeckSeatCount = 0
    let lowerDeckSeatCount = 0
    let maximumRowNumber = 0
    let maximumColumnNumber =0
    let lowestFare = Number.MAX_SAFE_INTEGER;
    let maximumRowNumberByColumnForLower = {};
    let maximumRowNumberByColumnForUpper = {}
   
    let showFareInLayout = getTravelsDetailsByKey('show_fare_in_layout');
    let seatMapping = {};

   let lowerDeckToiletKeys = new Set();
   let deckStats = {
       lower: { minCol: Number.MAX_SAFE_INTEGER, maxCol: 0, maxRowByCol: {} },
       upper: { minCol: Number.MAX_SAFE_INTEGER, maxCol: 0, maxRowByCol: {} }
   };
   // Side of the layout border an emergency exit points to: bottom when the seat is
   // the last row of its column, otherwise left/right for the window columns
   const getExitPosition = (item, stats) => {
       if (item.seat_row_number === stats.maxRowByCol[item.seat_column_number]) {
           return 'bottom';
       }
       if (item.seat_column_number === stats.minCol) {
           return 'left';
       }
       if (item.seat_column_number === stats.maxCol) {
           return 'right';
       }
       return 'bottom';
   };

   // The layout's feature_type decides the marker (Roof: in-cell up/down arrows,
   // Rear: bottom border, Side: the seat's window side); position is the
   // geometric fallback for exits saved before feature_type existed
   const getExitPositionByFeatureType = (item, stats) => {
       if (item.feature_type === 'Roof') {
           return 'roof';
       }
       if (item.feature_type === 'Rear') {
           return 'bottom';
       }
       if (item.feature_type === 'Side') {
           return item.seat_column_number === stats.minCol ? 'left' : 'right';
       }
       return getExitPosition(item, stats);
   };

   if(seats.length >0){
    seats.map((item,index)=>{
        seatMapping[item.seat_number] = item;
        const stats = item.upper_deck ? deckStats.upper : deckStats.lower;
        stats.minCol = Math.min(stats.minCol, item.seat_column_number);
        stats.maxCol = Math.max(stats.maxCol, item.seat_column_number);
        if (!isValid(stats.maxRowByCol[item.seat_column_number])
            || stats.maxRowByCol[item.seat_column_number] < item.seat_row_number) {
            stats.maxRowByCol[item.seat_column_number] = item.seat_row_number;
        }
        if (!item.upper_deck && item.seat_number === 'Empty' && item.seat_feature === 'Toilet') {
            lowerDeckToiletKeys.add(`${item.seat_row_number}-${item.seat_column_number}`);
        }
    })
       seats.map((item,index)=>{
           // A toilet spans both decks but is drawn once: when the same position
           // holds a toilet on the lower deck, the upper deck cell shows a blocked
           // space instead of the toilet block (an actual seat there is untouched)
           if (item.upper_deck && item.seat_number === 'Empty' && item.seat_feature === 'Toilet'
               && lowerDeckToiletKeys.has(`${item.seat_row_number}-${item.seat_column_number}`)) {
               item = { ...item, seat_feature: null, blocked_space: true };
           }
           if (item.seat_feature === 'Emergency Exit') {
               item = { ...item, exit_position: getExitPositionByFeatureType(item, item.upper_deck ? deckStats.upper : deckStats.lower) };
           }
           seatGrid = item.upper_deck ? upperSeatGrid : lowerSeatGrid
           seatgender=''
           className=''
           seattype = item.sleeper === 1 ? "sleeper " : "seater "
           if(item.sleeper === 1 && item.seat_orientation != 0){
            seattype = "sleeper-orientation"
           }
        //    if(item.seat_status === 'Confirmed'){
        //     if(item.gender==="F"){
        //       seatbooked='ladies-booked '
        //     }else{
        //       seatbooked='booked '
        //     }
        //     }else if(item.seat_status === 'Blocked'){
        //         if(isValid(item.time_of_release)){
        //             seatbooked="phone-blocked";
        //         }else{
        //             seatbooked=item.blocked_by === global.userName?"self-blocked":"others-blocked";
        //         }
        //     }else{
        //        seatbooked=''
        //        if(item.upper_deck) {
        //            upperDeckSeatCount++
        //        }else {
        //            lowerDeckSeatCount++
        //        }
        //    }
           if(item.amount_for_travels < lowestFare){
               lowestFare = item.amount_for_travels;
           }
           if(item.window_seat === 1){
               available_windowSeats++
           }
           if(item.seat_status !== 'Confirmed' && item.seat_status !== 'Blocked') {
               if (item.ladies_seat === 1) {
                   seatgender = ' ladies'
               }
               if (item.gents_seat === 1) {
                   seatgender = ' gents'
               }
           }
           if (item.seat_row_number !== row_number) {
               row_number++
           }
           if(col_number_array.indexOf(item.seat_column_number) === -1) {
               col_number_array.push(item.seat_column_number)
           }

           maximumRowNumber = item.seat_row_number > maximumRowNumber ? item.seat_row_number : maximumRowNumber;
           if(item.upper_deck){
            if(isValid(maximumRowNumberByColumnForUpper[item.seat_column_number])){
                if(maximumRowNumberByColumnForUpper[item.seat_column_number]['maximumRowNumber']<item.seat_row_number){
                    maximumRowNumberByColumnForUpper[item.seat_column_number]={maximumRowNumber:item.seat_row_number}
                }
            }else{
                maximumRowNumberByColumnForUpper[item.seat_column_number]={maximumRowNumber:item.seat_row_number}
            }
           }else{
            if(isValid(maximumRowNumberByColumnForLower[item.seat_column_number])){
                if(maximumRowNumberByColumnForLower[item.seat_column_number]['maximumRowNumber']<item.seat_row_number){
                    maximumRowNumberByColumnForLower[item.seat_column_number]={maximumRowNumber:item.seat_row_number}
                }
            }else{
                maximumRowNumberByColumnForLower[item.seat_column_number]={maximumRowNumber:item.seat_row_number}
            }
           }
          

           maximumColumnNumber = item.seat_column_number > maximumColumnNumber ? item.seat_column_number : maximumColumnNumber;

           className = seattype+seatbooked+seatgender
           let isSelected = false;
           if(isValidArray(selectedSeats)){
            if(selectedSeats.length>0 && selectedSeats.indexOf(item.seat_number)!==-1){
                isSelected = true;
            }else if(selectedSeats[item.id]!== undefined){
                isSelected = true;
            }
           } 
           const seat = <Seat type={seattype} classname={className} object={item}
            key={item.seat_number}
            onSeatCLick={onSeatCLick}
            isSelected = {isSelected}
            showFarePopOver = {showFarePopOver}
            dontAllowSelection={dontAllowSelection}
            changeOldLayout = {changeOldLayout}
            oldSelectedSeats = {oldSelectedSeats}
            showFareInLayout = {showFareInLayout}
            onSeatDrop = {(draggedSeat, targetSeat)=>onSeatDrop(draggedSeat,targetSeat,reloadSeatLayout)}
            onNotBoardedDrop = {(draggedSeat, targetSeat)=>onNotBoardedDrop(draggedSeat,targetSeat,reloadSeatLayout,reloadNotBoarded)}
            seatMapping = {seatMapping}
            isDragDropRequired = {isDragDropRequired}
           />

               if (seatGrid[item.seat_row_number]) {
                   seatGrid[item.seat_row_number][item.seat_column_number] = seat
               } else {
                   while (seatGrid[item.seat_row_number] === undefined) {
                       seatGrid.push([]);
                   }
                   seatGrid[item.seat_row_number][item.seat_column_number] = seat
               }

    })
    //    col_number=col_number_array[col_number_array.length-1]
       available_seats = lowerDeckSeatCount+upperDeckSeatCount
   }
   return {
    seatGridLayout:{
        lowerSeatGrid:lowerSeatGrid,
        upperSeatGrid:upperSeatGrid,
        row_count:maximumRowNumber,
        col_count:maximumColumnNumber,
        available_seats:available_seats,
        available_windowSeats:available_windowSeats,
        lower_seatCount:lowerDeckSeatCount,
        upper_seatCount:upperDeckSeatCount,
        maximumRowNumberByColumnForLower:maximumRowNumberByColumnForLower,
        maximumRowNumberByColumnForUpper:maximumRowNumberByColumnForUpper,
        bothDecksTogether: bothDecksTogether
       },
       lowestFare
   }
}
